import { Outlet } from 'react-router-dom';

const MinimalLayout = () => (
  <div>
    <Outlet />
  </div>
);

export default MinimalLayout;
